/*eslint no-script-url: 0 */
import React, { Component } from 'react';
import UploadImage from './Components/ImageManager/UploadImage';
import EditImage from './Components/ImageManager/EditImage';
import ResetImage from './Components/ImageManager/ResetImage';
import FramedSize from './Components/FrameSize/FramedSize';
import FramingOptions from './Components/FramingOptions';
import CartTotal from './Components/FramingOptions/CartTotal';
import AddToCart from './Components/Cart/AddToCart';
import Constants from './Config/Config';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import Tour from 'reactour';
import classNames from 'classnames';
import Parser from 'html-react-parser';

const URL = Constants.URL.root+'/wp-json/wp/v2/canvas-tour';

export default class FrameAreaRight extends Component {

	constructor(props, context) {
		super(props, context);
		this.updateHeight = this.updateHeight.bind(this);
		this.getSteps = this.getSteps.bind(this);
		this.updateSteps = this.updateSteps.bind(this);
		this.state = {
			steps: null,
            isTourOpen: false,
        }
	}

	getSteps() {
		var self = this;
		fetch(URL+'?per_page=100&filter[orderby]=menu_order&order=asc')
        .then(response => {
            if (!response.ok) {
                throw Error('Network request failed.')
            }
            return response;
        })
        .then(data => data.json())
        .then(data => {
            console.log(data);
            self.updateSteps(data);
        }, (ex) => {
			//self.setState({ error: ex.message });
			self.getSteps();
        })
    }

    updateSteps(data) {
    	let stepsArray = [];
		data.map( ( item ) =>
        	stepsArray.push(
        		{
        			selector: item.acf.selector,
        			content: function DemoHelperComponent() {
        				return ( <div><h4>{Parser(item.title.rendered)}</h4> {Parser(item.content.rendered)}</div>)
        			}
        		}
        	)
        )
		this.setState({ steps: stepsArray });
    }

	updateHeight() {
        this.props.dispatch({
			type: 'SET_STATE',
			state: {
				rightFrameHeight: this.divRef.clientHeight
			}
		})
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.updateHeight);
	}

	componentDidMount() {
        this.updateHeight();
        this.getSteps();
        window.addEventListener("resize", this.updateHeight);
    }

	toggleSteps = () => {
		this.props.dispatch({
			type: 'SET_STATE',
			state: {
				showMeHow: true
			}
		})
    	this.setState(prevState => ({ isTourOpen: !prevState.isTourOpen }));
  	}

  	toggleStepsToFalse = () => {
    	this.setState({ isTourOpen: false });
  	}

  	getCurrentStep = (curr) => {
  		//console.log(`The current step is ${curr + 1}`)
  		let currentStep = curr + 1;
  		let inStep = false;
		if (currentStep === 4) {
  			currentStep = 'stretching'
  			inStep = true
  		} else if (currentStep === 5) {
  			currentStep = 'wrapping'
  			inStep = true
  		} else if (currentStep === 6) {
  			currentStep = 'hanging'
  			inStep = true
  		} else if (currentStep === 7) {
  			currentStep = 'frames'
  			inStep = true
  		} else if (currentStep === 8) {
  			currentStep = 'wallcolor'
  			inStep = true
  		} else if (currentStep === 9) {
  			currentStep = 'roomview'
  			inStep = true
  		}

  		if (inStep) {
			this.props.dispatch({
				type: 'SET_STATE',
				state: {
					selectedTab: currentStep
				}
			})
		}
  	}

  	disableBody = target => disableBodyScroll(target)
	enableBody = target => enableBodyScroll(target)

	render() {
		//console.log(this.props.selectedTab);
		const stepClass = classNames('btn default-btn guide-me-btn', {'disabled': this.state.steps === null});
	    return (
	    	<div className="col-sm-5" ref={element => this.divRef = element}>
				<div className="controls">
					<div className="row">
						<div className="col-sm-12">
							<button onClick={this.toggleSteps} className={stepClass}><i className="fas fa-info"></i> Show me how</button>
						</div>
						<div className="col-sm-12">
							<strong style={{ textTransform: 'uppercase', display: 'block', width: '100%', backgroundColor: '#ffebc6', padding: '5px 20px', textAlign: 'center', margin: "15px 0" }}>Start by uploading your image</strong>
						</div>
					</div>
					{this.state.steps !== null &&
						<Tour
							steps={this.state.steps}
							isOpen={this.state.isTourOpen}
							onRequestClose={this.toggleSteps}
							rounded={4}
							onAfterOpen={this.disableBody}
	  						onBeforeClose={this.enableBody}
							getCurrentStep={curr => this.getCurrentStep(curr)}
							lastStepNextButton={`Finished`}
							nextButton={`Next`}
							prevButton={`Back`}
	  					/>
	  				}
				</div>
				<div className="cont_rgt">
					<div className="imageSizeWrapper">
						<div className="upload_image">
							<ul>
								<UploadImage
									{...this.props}
									toggleSteps={this.toggleStepsToFalse} />
								<EditImage
									{...this.props}
									toggleSteps={this.toggleStepsToFalse} />
								<ResetImage
									{...this.props} />
							</ul>
						</div>
						<div className="image-size-step">
							<FramedSize
								{...this.props} />
						</div>
					</div>
					<div className="summaryCheckoutWrapper">
						<FramingOptions {...this.props} />
						<CartTotal {...this.props} />
						<AddToCart {...this.props} />
					</div>
				</div>
			</div>
	    );
	}
}